/**
 * @desc 导入修改分区报价信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.logisticsQuotation.importAndModifyQuotationInfo.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotation/import/quotationInfoModify`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
